import { Component, inject, input, OnInit } from '@angular/core'
import { AbstractControl, FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { BricksCardComponent, BricksIconComponent } from '@enbw_bricks/ui'

import { RequiredFieldsComponent } from '../shared/components/required-fields/required-fields.component'
import { GeneralFormControls, OfferFormService } from '../shared/services/offer-form.service'
import { MatStepper } from '@angular/material/stepper'
import { ConsumptionInfoComponent } from './consumption-info/consumption-info.component'
import { TechnicalResourceDataComponent } from './technical-resource-data/technical-resource-data.component'
import { GeneralDataComponent } from './general-data/general-data.component'
import { NotificationService } from '../shared/components/notification/notification.service'
import { AbstractTrackEventsService } from '../shared/services/abstract-track-events.service'

@Component({
  selector: 'app-technical-data',
  imports: [
    ReactiveFormsModule,
    BricksCardComponent,
    BricksIconComponent,
    RequiredFieldsComponent,
    ConsumptionInfoComponent,
    TechnicalResourceDataComponent,
    GeneralDataComponent,
  ],
  templateUrl: './technical-data.component.html',
  styleUrls: ['./technical-data.component.scss'],
})
export class TechnicalDataComponent implements OnInit {
  readonly stepper = input<MatStepper>()
  readonly generalData = input<FormGroup<GeneralFormControls>>()
  protected isFormSubmitted = false
  private readonly trackEventService = inject(AbstractTrackEventsService)
  private readonly notificationService = inject(NotificationService)
  private readonly offerFormService = inject(OfferFormService)

  ngOnInit() {
    this.trackEventService.trackEvent('offer_funnel_started', 'Form', 'view', 'Angebotsstrecke')
  }

  onSubmit() {
    this.isFormSubmitted = true
    const generalData = this.generalData()

    if (generalData?.valid) {
      this.stepper()?.next()
      this.notificationService.clear()
      return
    }

    generalData?.markAllAsTouched()

    const hasMissingRequired = (control: AbstractControl): boolean =>
      control.hasError('required') ||
      control.hasError('requiredTrue') ||
      (control instanceof FormGroup && Object.values(control.controls).some(hasMissingRequired)) ||
      (control instanceof FormArray && control.controls.some(hasMissingRequired))

    if (generalData && hasMissingRequired(generalData)) {
      this.notificationService.clear()
      this.notificationService.missingDataError()
      return
    }

    this.offerFormService.checkSubsidizedPeriod() // some errors require dialog to be opened

    // some errors require global error to be shown
    this.offerFormService.checkCommissioningDateAgainstOperationStatus()
    this.offerFormService.checkTotalInstalledCapacity()
  }

  trackEventSubmit() {
    this.trackEventService.trackEvent('form_step_complete', 'Form', 'step_complete', 'Technical Data')
  }
}
